import postData from "../../dataFetcher/postDataFetcher";
import putData from "src/dataFetcher/putDataFetcher";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

export async function updateColumnPreferences(data, token) {
  const result = await putData(`${backendUrl}user/column-preference`, data, token);
  return result;
}
